import * as actionTypes from "../actionTypes";
import { createPropertyEvent as createPropertyEventMutation } from "../../../utils/appsyncOperations";

export const resolveInstanceLoading = () => ({
  type: actionTypes.RESOLVE_INSTANCE_LOADING,
});
export const resolveInstanceSuccess = (instance) => ({
  type: actionTypes.RESOLVE_INSTANCE_SUCCESS,
  instance,
});
export const resolveInstanceError = (error) => ({
  type: actionTypes.RESOLVE_INSTANCE_ERROR,
  error,
});
export const setProperty = (property) => ({
  type: actionTypes.SET_PROPERTY,
  property,
});
export const setProperties = (properties) => ({
  type: actionTypes.SET_PROPERTIES,
  properties,
});
export const setPropertyEvent = (propertyEvent) => ({
  type: actionTypes.SET_PROPERTY_EVENT,
  propertyEvent,
});
export const setPropertyEvents = ({ propertyEvents, lastVisited }) => ({
  type: actionTypes.SET_PROPERTY_EVENTS,
  propertyEvents,
  lastVisited,
});
export const setSelectedInstance = (instanceId) => {
  if (instanceId) {
    const timestamp = new Date().valueOf();
    localStorage.setItem(instanceId, timestamp.toString());
    return { type: actionTypes.SET_SELECTED_INSTANCE, instanceId, timestamp };
  } else {
    return { type: actionTypes.SET_SELECTED_INSTANCE, instanceId: null };
  }
};
export const setFilter = ({
  showPatrols = null,
  showActive = null,
  showVacationWatch = null,
  showInstance = null,
  showDefault = null,
  showKirs = null,
}) => ({
  type: actionTypes.SET_FILTER,
  showPatrols,
  showActive,
  showVacationWatch,
  showInstance,
  showKirs,
  showDefault,
});

export const createPropertyEvent = (propertyEvent) => async (
  dispatch,
  getState
) => {
  dispatch(setPropertyEvent({ ...propertyEvent, pending: true }));
  try {
    const createdPropertyEvent = await createPropertyEventMutation(
      propertyEvent
    );
    dispatch(setPropertyEvent(createdPropertyEvent));
  } catch (error) {
    dispatch(setPropertyEvent({ ...propertyEvent, error }));
  }
};
